import { render, staticRenderFns } from "./AddDeliveries.vue?vue&type=template&id=2b16c286&scoped=true"
import script from "./AddDeliveries.vue?vue&type=script&lang=js"
export * from "./AddDeliveries.vue?vue&type=script&lang=js"
import style0 from "./AddDeliveries.vue?vue&type=style&index=0&id=2b16c286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b16c286",
  null
  
)

export default component.exports